import React, { FunctionComponent, ReactNode } from "react"

interface ISpoilerProps {
    id?: any
    toggleEl(expanded: boolean, toggle: () => void): ReactNode
    onToggle(expanded: boolean, id: any): void
    expanded?: boolean
}

const Spoiler: FunctionComponent<React.PropsWithChildren<ISpoilerProps>> = ({
    id,
    toggleEl,
    onToggle,
    expanded = false,
    children
}) => {
    function toggle() {
        onToggle(!expanded, id)
    }

    return (
        <>
            {toggleEl(expanded, toggle)}
            {expanded && children}
        </>
    )
}

export default Spoiler
